module.exports = __webpack_public_path__ + "static/img/10.835eef6b.png";